export const ProTacticsBanner = () => (
  <section
    className={`relative h-[186px] min-w-[375px] touch-device:mt-2 bg-cover bg-center bg-no-repeat bg-[url('https://cdn.easysbc.io/fc25/banners/play-like-a-pro/mobile_w_tekkz.png')] 
        touch-device:bg-[url('https://cdn.easysbc.io/fc25/banners/play-like-a-pro/desktop_w_tekkz.png')] touch-device:bg-left touch-device:h-[232px] x-large:h-[300px]`}
  >
    <div className="absolute hidden sb-v2-lg:flex text-[64px] x-large:text-[78px] x-large:w-fit text-white font-semibold right-8 top-2 leading-[90px]">
      Play like the Pros
    </div>

    <div className="absolute hidden touch-device:flex text-[62px] w-[270px] pro-banner:w-fit sb-v2-lg:hidden text-white font-semibold right-2 pro-banner:right-8 top-4 leading-[70px]">
      Play like the Pros
    </div>
    <img
      className="hidden touch-device:flex absolute bottom-4 right-8 w-[180px] pro-banner:w-[260px]"
      alt="easysbc"
      src={
        "https://cdn.easysbc.io/fc25/banners/play-like-a-pro/partners_logo.png"
      }
    />
  </section>
);
